import React from 'react';
import { ArrowLeft, BookPlus, Check, Clock3 } from 'lucide-react';
import { t } from '../i18n';
import './LearningSessionHeader.css';

export function formatLearningTime(value = 0) {
  const seconds = Math.max(0, Math.floor(Number(value) || 0));
  return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
}

export function LearningExitButton({ children, className = '', title, ...props }) {
  return <button type="button" aria-label={children} title={title || children} {...props} className={`learning-exit-button ${className}`.trim()}>
    <ArrowLeft size={22} aria-hidden="true" />
    <span className="learning-exit-label">{children}</span>
  </button>;
}

export function LearningImportButton({ imported = false, disabled = false, ...props }) {
  const label = t(imported ? 'quickPractice.imported' : 'quickPractice.importToNotes');
  return <button type="button" {...props} className="learning-import-button" aria-label={label} title={label} disabled={disabled || imported}>
    {imported ? <Check size={20} aria-hidden="true" /> : <BookPlus size={20} aria-hidden="true" />}
  </button>;
}

export default function LearningSessionHeader({
  title, elapsedSeconds = 0, timeLimitSeconds = null, onExit, exitLabel,
  exitDisabled = false, exitTitle, leftTools, rightTools, className = '', ...props
}) {
  return <header {...props} className={`learning-session-header ${className}`.trim()}>
    <div className="learning-session-heading">
      <LearningExitButton onClick={onExit} disabled={exitDisabled} title={exitTitle}>{exitLabel}</LearningExitButton>
      <div className="learning-session-title">{title}</div>
    </div>
    <div className="learning-session-tools">
      <div className="learning-session-tools-left">{leftTools}</div>
      <div className="learning-session-clock" role="timer" aria-label={t('interface.practice.title')} aria-live="off">
        <Clock3 size={17} strokeWidth={2.2} aria-hidden="true" />
        <span>{formatLearningTime(elapsedSeconds)}{timeLimitSeconds != null && ` / ${formatLearningTime(timeLimitSeconds)}`}</span>
      </div>
      <div className="learning-session-tools-right">{rightTools}</div>
    </div>
  </header>;
}
